<template>
    <ideo-collapse v-model="chatsVisible">
        <ideo-button
            class="chat-btn"
            v-for="(chat, index) in list"
            :key="index"
            @click="currentChatPublicId = chat.publicId"
            :variant="statusArchived(chat.status) ? 'primary' : 'success'"
        >
            <i class="fa fa-message" />
            {{ chat.name }}
            <span v-if="chat.hasNewMessages">{{ $t('[[[(nowe wiadomości)]]]') }}</span>
        </ideo-button>
        <chat-view
            v-if="currentChatPublicId"
            :chat-public-id="currentChatPublicId"
            @chatClosed="currentChatPublicId = ''"
        />
    </ideo-collapse>
</template>
<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Options, Vue } from 'vue-class-component';
import { StatusEnum } from '../services/ChatService';
import { ChatRoomsListItemModel } from "@/modules/renter/chat/services/ChatService";
import ChatView from './ChatView.vue';

@Options({
    components: { ChatView }
})
export default class RenterChatsList extends Vue
{
    @Prop({ default: false }) public chatsVisible: boolean;
    @Prop({ default: [] }) public list: ChatRoomsListItemModel[];

    public statusArchived(status: string): boolean
    {
        return StatusEnum[status] === StatusEnum.Archival;
    }

    public currentChatPublicId: string = '';
}
</script>
<style scoped>
.chat-btn{
    width: 100%;
    margin-top: 10px;
}
</style>